var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * @Author: your name
 * @Date: 2020-02-16 14:25:06
 * @LastEditTime: 2020-03-14 21:06:00
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \kkcloud-kk-bote\src\utils\service-common.ts
 */
import replace from 'lodash/replace';
import { of } from 'rxjs';
import { zip } from 'rxjs/operators';
/**
 * 字符串解密
 * @param st
 */
var encodeStr = function (st) {
    var a = replace(replace(replace(st, /\&/g, '8'), /\*/g, 'c'), /\%/g, 'a');
    var b = a
        .split('')
        .reverse()
        .join('');
    return b;
};
/**
 * 拼接字符串
 * @param a
 * @param b
 * @param c
 * @param f
 */
var pieceStr = function (a, b, c) {
    var str = '';
    of(a)
        .pipe(zip(of(b), of(c)))
        .subscribe(function (values) {
        str = values.reverse().join('');
    });
    return str;
};
/**
 * 接口签名算法加密
 * @param params 这个参数只是为了动态化参数，防止被tree-shaking给压缩了
 */
export var getSecret = function (params) {
    if (params === void 0) { params = {}; }
    var sA = process.env.appSecuritA;
    var sB = process.env.appSecuritB;
    var sC = process.env.appSecuritC;
    window._serviceTimer = Date.now();
    return __assign(__assign({}, params), { data: pieceStr(encodeStr(sA), encodeStr(sB), encodeStr(sC)) });
};
/**
 * 拼接AppKey 签名参数
 * @param params 这个参数只是为了动态化参数，防止被tree-shaking给压缩了
 */
export var getAppKey = function (params) {
    if (params === void 0) { params = {}; }
    var kA = process.env.appKeyA;
    var kB = process.env.appKeyB;
    var kC = process.env.appKeyC;
    return __assign(__assign({}, params), { data: pieceStr(encodeStr(kA), encodeStr(kB), encodeStr(kC)) });
};
